import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { ordersRoutingModule } from './orders-routing.module';
import { ImportsPrimeModule } from 'src/app/_material/primeng.module';
import { SharedComponentsModule } from '../../shared/shared-components/shared-components.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { ordersComponent } from '../components/orders/orders.component';
import { AddordersComponent } from '../components/add-orders/add-orders.component';
import { draftOrdersComponent } from '../components/draft-order/draft-orders.component';
import { ordersDetailsComponent } from '../components/order-details/orders-details.component';
import { AddComponentComponent } from '../components/add-component/add-component.component';
import { RemoveComponentComponent } from '../components/remove-component/remove-component.component';
import { ExchangeComponentComponent } from '../components/exchange-component/exchange-component.component';
import { swapComponentComponent } from '../components/swap-component/swap-component.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TyrePositionComponentDrag } from '../components/tyre-position/tyre-position.component';
import { TyrePositionDragDropComponent } from '../components/tyre-position-drag-drop/tyre-position-drag-drop.component';
import { trailerTyrePositionComponentDrag } from '../components/trailer-tyre-position/trailer-tyre-position.component';


@NgModule({
  declarations: [
    ordersComponent,
    AddordersComponent,
    draftOrdersComponent,
    ordersDetailsComponent,
    AddComponentComponent,
    RemoveComponentComponent,
    ExchangeComponentComponent,
    swapComponentComponent
  ],
  imports: [
    CommonModule,
    ordersRoutingModule,
    FormsModule,
    ImportsPrimeModule,
    DatePipe,
    SharedModule,
    SharedComponentsModule,
    DragDropModule,
    TyrePositionComponentDrag,
    TyrePositionDragDropComponent,
    trailerTyrePositionComponentDrag
  ]
})
export class ordersModule { }
